module.exports = __webpack_public_path__ + "img/language.940a2bbf.svg";